<template>
  <div>
    <loading-overlay :isLoading="loading"></loading-overlay>
    <div class="row">
      <card :title="'Proiecte'">
        <base-table :data="tableData"
                    :columns="columns">
          <template slot="columns">
            <th class="text-left">#</th>
            <th style="width: 30%">Denumire lucrare</th>
            <th>Oras</th>
            <th>Strada</th>
            <th>Autorizatie</th>
            <th>Client</th>
            <th>Incasari</th>
            <th class="text-right">
              <base-button v-tooltip="'Adauga proiect nou'" @click="addProject" type="info" size="sm" icon>
                <i class="tim-icons icon-simple-add"></i>
              </base-button>
            </th>
          </template>
          <template slot-scope="{row}">
            <td v-bind:class="{'btn-info': selected_project && row.id === selected_project.id }"  @click="viewProjectDetails(row)">{{row.id}}</td>
            <td @click="viewProjectDetails(row)" class="clickable">{{row.lucrari}}</td>
            <td @click="viewProjectDetails(row)" class="clickable">{{row.lucrare_oras}}</td>
            <td @click="viewProjectDetails(row)" class="clickable">{{row.lucrare_str}}</td>
            <td @click="viewProjectDetails(row)" class="clickable">{{row.nr_aut}}/{{row.data_aut}}</td>
            <td @click="viewProjectDetails(row)" class="clickable">{{row.customer.nume}}</td>
            <td @click="viewProjectDetails(row)" class="clickable">
              <div class="progress" style="height: 15px; width: 80px">
                <div class="progress-bar" role="progressbar" v-bind:style="{ width: row.totalCashed + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{row.totalCashed}}%</div>
              </div>
            </td>
            <td class="td-actions text-right" style="white-space: nowrap">
              <base-button v-tooltip="'Vezi date financiare proiect'" @click="viewFinancials(row)" type="primary" size="sm" icon style="margin-left: 10px">
                <i class="tim-icons icon-money-coins"></i>
              </base-button>
              <base-button v-tooltip="'Editeaza proiect'" @click="editProject(row)" type="success" size="sm" icon style="margin-left: 10px">
                <i class="tim-icons icon-settings"></i>
              </base-button>
              <base-button v-tooltip="'Sterge proiect'" @click="deleteProject(row)" type="danger" size="sm" icon style="margin-left: 10px">
                <i class="tim-icons icon-simple-remove"></i>
              </base-button>
            </td>
          </template>
        </base-table>
        <div v-if="tableData.length < 1 && !loading" style="text-align: center">
          <h6 class="blockquote">Nu exista proiecte adaugate!</h6>
        </div>
      </card>
    </div>
    <div class="row">
      <card class="card">
        <h4 slot="header" class="card-title">Nota</h4>
        <p>*Selecteaza proiectul pentru care doresti sa generezi formularele! </p>
      </card>
    </div>
  </div>

</template>

<script>
  import { BaseTable } from "@/components";
  import axios from "axios"
  import LoadingOverlay from "../../components/Loading/LoadingOverlay";

  export default {
    components: {BaseTable, LoadingOverlay},
    data() {
      return {
        columns: ['Denumire lucrare', 'Oras', 'Strada', 'Autorizatie', ''],
        tableData: [],
        formSidebarVisible: false,
        selected_project: null,
        baseDocumentGenerationUrl: null,
        loading: false,
      }
    },
    created() {
      this.getData();
    },
    methods: {
      async getData() {
        this.loading = true;
        await axios.post('projects', {customerId: this.$route.params.customerId})
                .then(res => {
                  this.loading = false;
                  this.tableData = res.data.projects;
                  if (res.data.url.indexOf('127.0.0.1') === -1) {
                    this.baseDocumentGenerationUrl = res.data.url.replace("http", "https");
                  } else {
                    this.baseDocumentGenerationUrl = res.data.url;
                  }
                })
                .catch(err => {
                  this.loading = false;
                  console.log(err);
                })
      },
      addProject() {
        this.$router.push({name: 'project-add'});
      },
      viewFinancials(project) {
        this.$router.push({name: 'project-finances', params: {projectId: project.id} });
      },
      editProject(project) {
        this.$router.push({name: 'project-edit', params: {projectId: project.id} });
      },
      deleteProject(project) {
        let self = this;
        this.$dialog.confirm('Esti sigur ca vrei sa stergi proiectul "' + project.lucrari + '"?', {
          okText: 'Da',
          cancelText: 'Nu'
        })
                .then(() => {
                  axios.post('project/delete', {id: project.id})
                          .then(() => {
                            self.getData();
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                })
                .catch(() => {
                })
      },
      viewProjectDetails(project) {
        this.$router.push({name: 'project-view', params: {projectId: project.id, project: project, baseDocumentGenerationUrl: this.baseDocumentGenerationUrl} });
      },
    },
  }
</script>
<style scoped>
  .clickable {
    cursor: pointer;
  }
</style>